import React from 'react';

const Divider = ({content}) => {
    return (
        <div className="is-divider" data-content={content}></div>
    )
}

export default Divider
